import { useEffect, useState } from 'react';
import './ContactForm.scss';

const ContactSection = () => {
  const [formLoaded, setFormLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '48974364',
          formId: '0132085e-d28d-474d-9c7e-63416e8a84b2',
          target: '#hubspot-form',
          onFormReady: () => {
            setTimeout(() => {
              setFormLoaded(true);
            }, 500); // or 600–800ms if needed
          }
        });
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <section className="contact-form section">
      <div className="wrapper wrapper--large">
        <div className="row">
          <div className="col">
            <h2 className="wrapper__title">Vamos Trabalhar Juntos</h2>
            <p>
              Tem uma questão ou projeto em mente? Entre em contacto connosco!
            </p>
            <img
              className="contact-form__illustration"
              src="/images/homepage/illustrations/contact-form-illustration.webp"
              alt=""
            />
          </div>

          <div className="col">
            <h2 className="wrapper__title">Fale Connosco!</h2>
            <div className={`contact-form-wrapper ${formLoaded ? 'contact-form-loaded' : ''}`}>
              {!formLoaded && <div className="contact-form-placeholder">A carregar formulário…</div>}
              <div id="hubspot-form"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;